const amenitiesList = {
    'interior amenities': [
        'Exremely spacious two story design',
        '3 Bedrooms / 2.5 Baths',
        'Master suite with private bath and walk-in closet',
        'Gourmet kitchen with island and pantry',
        'Granite countertops throughout',
        'Stainless steel kitchen appliances all included',
        'Separate laundry room with full size front load washer & dryer'
    ],
    'exterior amenities': [
        'Brand new construction',
        'Individual full size garage',       
        'Painted trim and doors',
        'Individual driveway, patio, and yard space'
    ],
    other: [
        'Each townhome rents for $1750/mo plus utilities',
        'High speed internet available',
        'Lawn care and snow removal is included',
        'Locally owned and managed',
        'Conveniently located near Levis Commons and I-75 / 475 / US-23' 
    ]
}

export default amenitiesList;